<template>
  <div id="footer">
    <div class="container">
      <div class="row">
        <div class="col-6 align-self-center">
          <div class="row">
            <img src="../assets/images/logo_white.png"  style="height:50px" alt="">
          </div>
        </div>
        <div class="col-6">
          <ul>
            <li>
              POWERED BY
            </li>
            <li>
              <a href="#">TERMS AND CONDITIONS</a>
            </li>
            <li>
              <a href="#">
                PRIVACY POLICY
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
/*--------------------- FOOTER ------------------*/
#footer{
  padding-top:50px;
  padding-bottom: 50px;
  background:linear-gradient(to right,rgba(208, 247, 32, 0.788),rgb(235, 129, 67))
}
#footer ul {
  float:right;
}
#footer ul li{
  list-style: none;
  color:#fff;
  padding:5px 0;
  font-size: .8em !important;
}
#footer ul li a{
  text-decoration: none;
  color:#fff;
}
</style>